const types = {
    EVENT: 'gameEvent',
    SELECT_ACTIVE_ROOM_TAB: 'selectActiveRoomTab',
    SET_ACTIVE_PAGE: 'setActivePage',
    SET_PROMO_DATA: 'setPromoData',
    DELETE_SINGLE_PROMO: 'deleteSinglePromo',
    ADD_SINGLE_PROMO: 'addSinglePromo',
    OPEN_MODAL: 'lobbyOpenModal',
    CLOSE_MODAL: 'closeLobbyModal',
    SET_SERVER_MESSAGE: 'setServerMessage',
    SET_SERVER_BONUS_MESSAGE: 'setServerBonusMessage',
    SET_LOADER: 'lobbySetLoader',
    UNSET_LOADER: 'lobbyUnSetLoader',
    SET_RAKE_RACE_DATA: 'setRakeRaceData',
    UPDATE_RAKE_RACE_PROGRESS_LEADER_BOARD: 'updateRakeRaceProgressLeaderBoard',
    TOGGLE_AUDIO: 'toggleAudio',
    SET_MAINTENANCE: 'lobbySetMaintenance'
};
export default types
